/* tslint:disable */
/* eslint-disable */
/**
 * Brandside Backend API
 * REST API бэкенда Brandside. Авторизация — Bearer-токен Laravel Passport (заголовок Authorization: Bearer token). Успешные ответы оборачиваются в конверт success_response — status: true, data: ...; ошибки — common_error_response — status: false, errors._common: сообщение.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from '../runtime'
import type {
  GetCommonState400Response,
  GetInstruction404Response,
  GetNewsItem200Response,
  GetNewsList200Response,
} from '../models/index'
import {
  GetCommonState400ResponseFromJSON,
  GetCommonState400ResponseToJSON,
  GetInstruction404ResponseFromJSON,
  GetInstruction404ResponseToJSON,
  GetNewsItem200ResponseFromJSON,
  GetNewsItem200ResponseToJSON,
  GetNewsList200ResponseFromJSON,
  GetNewsList200ResponseToJSON,
} from '../models/index'

export interface GetNewsItemRequest {
  slug: string
}

export interface GetNewsListRequest {
  page?: number
  perPage?: number
  categories?: Array<string>
}

/**
 * NewsApi - interface
 *
 * @export
 * @interface NewsApiInterface
 */
export interface NewsApiInterface {
  /**
   * Опубликованная новость по slug: полный конструктор контента, обложка и релевантные новости. Неизвестный slug или запись чужого типа — 404. Ответ кэшируется в Redis.
   * @summary Новость по slug
   * @param {string} slug Slug новости
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof NewsApiInterface
   */
  getNewsItemRaw(
    requestParameters: GetNewsItemRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<GetNewsItem200Response>>

  /**
   * Опубликованная новость по slug: полный конструктор контента, обложка и релевантные новости. Неизвестный slug или запись чужого типа — 404. Ответ кэшируется в Redis.
   * Новость по slug
   */
  getNewsItem(
    requestParameters: GetNewsItemRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<GetNewsItem200Response>

  /**
   * Список опубликованных новостей: карточки с пагинацией и фильтром по категориям, плюс список категорий новостей. Ответ кэшируется в Redis.
   * @summary Список новостей
   * @param {number} [page] Номер страницы (по умолчанию 1)
   * @param {number} [perPage] Новостей на странице (по умолчанию 10)
   * @param {Array<string>} [categories] Фильтр по названиям категорий
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof NewsApiInterface
   */
  getNewsListRaw(
    requestParameters: GetNewsListRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<GetNewsList200Response>>

  /**
   * Список опубликованных новостей: карточки с пагинацией и фильтром по категориям, плюс список категорий новостей. Ответ кэшируется в Redis.
   * Список новостей
   */
  getNewsList(
    requestParameters: GetNewsListRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<GetNewsList200Response>
}

/**
 *
 */
export class NewsApi extends runtime.BaseAPI implements NewsApiInterface {
  /**
   * Опубликованная новость по slug: полный конструктор контента, обложка и релевантные новости. Неизвестный slug или запись чужого типа — 404. Ответ кэшируется в Redis.
   * Новость по slug
   */
  async getNewsItemRaw(
    requestParameters: GetNewsItemRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<GetNewsItem200Response>> {
    if (requestParameters['slug'] == null) {
      throw new runtime.RequiredError(
        'slug',
        'Required parameter "slug" was null or undefined when calling getNewsItem().'
      )
    }

    const queryParameters: any = {}

    const headerParameters: runtime.HTTPHeaders = {}

    const response = await this.request(
      {
        path: `/api/v1/news/{slug}`.replace(
          `{${'slug'}}`,
          encodeURIComponent(String(requestParameters['slug']))
        ),
        method: 'GET',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides
    )

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      GetNewsItem200ResponseFromJSON(jsonValue)
    )
  }

  /**
   * Опубликованная новость по slug: полный конструктор контента, обложка и релевантные новости. Неизвестный slug или запись чужого типа — 404. Ответ кэшируется в Redis.
   * Новость по slug
   */
  async getNewsItem(
    requestParameters: GetNewsItemRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<GetNewsItem200Response> {
    const response = await this.getNewsItemRaw(requestParameters, initOverrides)
    return await response.value()
  }

  /**
   * Список опубликованных новостей: карточки с пагинацией и фильтром по категориям, плюс список категорий новостей. Ответ кэшируется в Redis.
   * Список новостей
   */
  async getNewsListRaw(
    requestParameters: GetNewsListRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<GetNewsList200Response>> {
    const queryParameters: any = {}

    if (requestParameters['page'] != null) {
      queryParameters['page'] = requestParameters['page']
    }

    if (requestParameters['perPage'] != null) {
      queryParameters['perPage'] = requestParameters['perPage']
    }

    if (requestParameters['categories'] != null) {
      queryParameters['categories'] = requestParameters['categories']
    }

    const headerParameters: runtime.HTTPHeaders = {}

    const response = await this.request(
      {
        path: `/api/v1/news`,
        method: 'GET',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides
    )

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      GetNewsList200ResponseFromJSON(jsonValue)
    )
  }

  /**
   * Список опубликованных новостей: карточки с пагинацией и фильтром по категориям, плюс список категорий новостей. Ответ кэшируется в Redis.
   * Список новостей
   */
  async getNewsList(
    requestParameters: GetNewsListRequest = {},
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<GetNewsList200Response> {
    const response = await this.getNewsListRaw(requestParameters, initOverrides)
    return await response.value()
  }
}
